import {
  INTERNAL_IN_PROGRESS,
  // EXTERNAL_SUBMITTED
} from "../redux/actionTypes/actionsTypes"
import { ProfileOverviewState } from "../redux/reducers/getProfile/getProfileOverviewReducer"
import { CampaignSummaryType } from "../types/profile/CampaignSummary";
import { GroupCampaignsByYear } from "../types/profile/GroupCampaignsByYear";

export const excludeCampaignYears = [2020]
export const displayPreviousYearsNumber = 4;

export const isCurrentCampaignDisplayed = (profileOverview: ProfileOverviewState) => {
  if (profileOverview && profileOverview.profile && profileOverview.status === 200) {
    const current_campaign = profileOverview.profile.current_campaign
    if (current_campaign) {
      if (sessionStorage.getItem("isInternalUser") || [
        INTERNAL_IN_PROGRESS,
        // EXTERNAL_SUBMITTED
      ].includes(current_campaign.statusCode as string)) {
        return true
      }
    }
  }
  return false
}

export const isPreviousCampaignListDisplayed = (profileOverview: ProfileOverviewState) => {
  if (profileOverview && profileOverview.profile && profileOverview.status === 200) {
    const previous_campaigns = profileOverview.profile.previous_campaigns
    const excluded_campains = previous_campaigns.filter((c) => !excludeCampaignYears.includes(c.year))
    if (excluded_campains.length > 0) {
      if (sessionStorage.getItem("isInternalUser")) {
        return true
      } else {
        const valid_previous_campaigns = excluded_campains.filter((c) => c.currentSnapshotId)
        if (valid_previous_campaigns.length > 0) {
          const sorted = valid_previous_campaigns.sort((a, b) => b.year - a.year)
          const latest_campaign = sorted[0]
          const current_campaign = profileOverview.profile.current_campaign
          if (current_campaign && latest_campaign.year >= current_campaign.year - displayPreviousYearsNumber) {
            return true
          }
        }
      }
    }
  }
  return false
}

export const isCampaignListDisplayed = (profileOverview: ProfileOverviewState) => {
  if (profileOverview && profileOverview.profile && profileOverview.status === 200) {
    if (!isProfileTypeImportEligible(profileOverview.profile.profile_type_code)) {
      return false
    }
    return isCurrentCampaignDisplayed(profileOverview) || isPreviousCampaignListDisplayed(profileOverview)
  }
  return false
}

export const isProfileTypeImportEligible = (profileTypeCode: string) => {
  const eligibleProfileTypesForImport: string[] = ["BIP", "HTL", "MTL", "LRH", "LTC", "RHO", "GLF", "LLE"];
  return eligibleProfileTypesForImport.includes(profileTypeCode);
}

export const isInternalPortalCampaignEligibleForImport = (campaignList: GroupCampaignsByYear[], selectedProfileId: string, selectedCampaignYear: number, isInternalUser: boolean) => {
  if (!campaignList || !isInternalUser) return false;

  let importEligible = false;

  const previousYearCampaign = campaignList.find(
    ({ year }) => Number(year) === selectedCampaignYear - 1
  );

  if (previousYearCampaign) {
    const campaignForSelectedProfile = previousYearCampaign.campaigns.find(({ profileId }) => profileId === Number(selectedProfileId));

    if (campaignForSelectedProfile && ["EXTERNAL_SUBMITTED", "INTERNAL_IN_PROGRESS"].includes(String(campaignForSelectedProfile.statusCode))) {
      importEligible = true;
    }
  }
  return importEligible;
}

export const isExternalPortalCampaignEligibleForImport = (campaignList: CampaignSummaryType[]) => {
  let importEligible = false;
  const activeCampaignYear = Number(process.env.REACT_APP_ACTIVE_CAMPAIGN_YEAR);

  const previousYearCampaign = campaignList.find(
    ({ year }) => Number(year) === activeCampaignYear - 1
  );

  if (previousYearCampaign && ["EXTERNAL_SUBMITTED", "INTERNAL_IN_PROGRESS"].includes(String(previousYearCampaign.statusCode))) {
    importEligible = true;
  }
  return importEligible;
}